// frontend/src/components/FuturesTab.jsx
import { getFuturesConfig } from '../config/sportsConfig';
import { colors, fontFamily } from '../theme';
import { useDragScroll } from '../hooks';

export default function FuturesTab({ futuresData, futuresLoading, activeFuturesLeague, onSelectLeague, betSlip, onAddToBetSlip }) {
  const allMarkets = futuresData ? Object.values(futuresData).flat() : [];
  const activeMarket = allMarkets.find(m => m.key === activeFuturesLeague) || allMarkets[0];
  const leagueScroll = useDragScroll();

  return (
    <div style={{ fontFamily }}>
      {allMarkets.length > 0 && (
        <div
          ref={leagueScroll.ref}
          className="flex items-center gap-1.5 px-3 py-2 overflow-x-auto scrollbar-hide drag-scroll"
          onMouseDown={leagueScroll.onMouseDown}
          onMouseLeave={leagueScroll.onMouseLeave}
          onMouseUp={leagueScroll.onMouseUp}
          onMouseMove={leagueScroll.onMouseMove}
        >
          {allMarkets.map(market => {
            const cfg = getFuturesConfig(market.key);
            const isActive = market.key === activeMarket?.key;
            return (
              <button
                key={market.key}
                onClick={() => onSelectLeague(market.key)}
                className="flex-shrink-0 flex items-center gap-1.5 px-3 py-2 rounded-lg transition text-xs md:text-sm"
                style={{ background: isActive ? colors.goldActiveBg : colors.sectionBg, color: colors.textPrimary }}
              >
                <span className="text-base md:text-lg">{market.icon || cfg.icon}</span>
                <span className="font-medium whitespace-nowrap">{cfg.name !== market.key ? cfg.name : market.displayName}</span>
              </button>
            );
          })}
        </div>
      )}

      <div className="px-3 pb-24">
        {futuresLoading ? (
          <div className="text-center py-12 text-sm" style={{ color: colors.textFaint }}>Loading futures…</div>
        ) : !activeMarket ? (
          <div className="text-center py-12 text-sm" style={{ color: colors.textFaint }}>No futures markets available</div>
        ) : (
          <div>
            <h3 className="text-[19px] font-semibold mb-3" style={{ color: colors.textPrimary }}>{activeMarket.displayName}</h3>
            <div className="grid grid-cols-2 md:grid-cols-3 gap-2">
              {activeMarket.outcomes.map((outcome) => {
                const bet = {
                  type: 'futures',
                  futuresKey: activeMarket.key,
                  sportKey: activeMarket.sport_key,
                  sportTitle: activeMarket.displayName,
                  gameDescription: activeMarket.displayName,
                  selection: outcome.name,
                  odds: outcome.odds,
                };
                const isSelected = betSlip.some(b => b.type === 'futures' && b.futuresKey === activeMarket.key && b.selection === outcome.name);
                return (
                  <button
                    key={outcome.name}
                    onClick={() => onAddToBetSlip(bet)}
                    className="rounded-lg px-3 py-2.5 flex flex-col items-center justify-center transition active:scale-95"
                    style={{ background: isSelected ? colors.cardBgActive : colors.sectionBg, color: colors.textPrimary }}
                  >
                    <div className="text-[15px] font-semibold text-center">{outcome.name}</div>
                    <div className="text-[20px] font-bold mt-1" style={{ color: isSelected ? colors.textPrimary : colors.odds }}>{outcome.formatted}</div>
                  </button>
                );
              })}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
